import create from 'zustand'
import {immer} from "zustand/middleware/immer";
import { devtools, persist } from 'zustand/middleware'

//https://dev.to/franciscomendes10866/zustand-and-immer-with-react-5ajh
let useStore = immer( (set) => ({
    index:0,
    locale:'es',
    locales:[],
    isAuth: false,
    random:null,
    user: null,
    token:null,
    settings: null,
    slides:[],
    books:[],
    localBooks:{},
    shopingCart:[],
    authors: [],
    localAuthors:{},
    language: {},
    current: new Date(),
    addBook: (book) => set((state) => {state.shopingCart.push(book)}),
    sortBook: (sortFun) => set((state) => {
        state.shopingCart.sort(sortFun)
    }),
    removeBook: id => set((state) => {
        const bookIndex = state.shopingCart.findIndex(book => book._id === id)
        state.shopingCart.splice(bookIndex, 1)
    }),
    updateBook: (book) => set((state) => {
        const bookIndex = state.shopingCart.findIndex(el => el._id === book._id)
        state.shopingCart[bookIndex] = book
    }),
    removeBook: (book) => set((state) => {
        state.books = state.books.filter(bck => bck._id !== book._id)
    })
}))

useStore = persist(devtools(useStore, { enabled: true}), {
    name: 'persist:editorialhumanidades',
    // getStorage: () => localStorage,
    getStorage: () => sessionStorage,
})

export const useAppStore = create(useStore)
